export interface WindowErrors {
  error: string;
  flashError: string;
  flashSuccess: string;
}

/**
 * Emburse login is enabled by default, but can be disabled by either:
 * local storage key `emburse_login` is set to 'false'.
 * Or `useEmburseLogin` query parameter is explicitly 'false'
 *
 * @param searchUri - The URL search string (e.g., `?useEmburseLogin=false`).
 * @returns `true` if Emburse login should be enabled; otherwise `false`.
 */
export function emburseLoginEnabled(searchUri: string) {
  // if login disabled by local storage
  if (localStorage && localStorage['emburse_login'] === 'false') {
    return false;
  }

  if (localStorage && localStorage['emburse_login'] === 'true') {
    return true;
  }

  // if no local storage or search params, default to emburse login enabled
  if (URLSearchParams && searchUri) {
    let searchParams = new URLSearchParams(searchUri);

    if (searchParams.get('useEmburseLogin') === 'false') {
      return false;
    }

    if (searchParams.get('useEmburseLogin') === 'true') {
      return true;
    }
  }

  if (window?.FEATURES?.emburse_login_redirect_all) {
    return true;
  }

  return false;
}

export function getCompanyIdFromUrl(searchUri: string) {
  if (!URLSearchParams || !searchUri) {
    return null;
  }

  const searchParams = new URLSearchParams(searchUri);
  if (!searchParams) {
    return null;
  }

  return searchParams.get('company_id');
}
